var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHorizontalGroupableChartIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.9816 19.8271H0.445312V0.794922H1.39227V18.8803H20.9816V19.8271Z",
    fill: "#4F6E90"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2031 1.83008L12.2031 2.0669L12.2031 3.66508L3.65497 3.66508L3.65497 1.83008L12.2031 1.83008Z",
    fill: "#4F6E90"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2031 13.5332L12.2031 13.77L12.2031 15.3682L3.65434 15.3682L3.65434 13.5332L12.2031 13.5332Z",
    fill: "#4F6E90"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1758 7.68164L16.1758 7.91846L16.1758 9.51664L3.6567 9.51664L3.6567 7.68164L16.1758 7.68164Z",
    fill: "#4F6E90"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2539 3.66602L10.2539 3.90283L10.2539 5.50102L3.65446 5.50102L3.65446 3.66602L10.2539 3.66602Z",
    fill: "#8DADD0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2188 15.3691L17.2187 15.606L17.2187 17.2041L3.6567 17.2041L3.6567 15.3691L17.2188 15.3691Z",
    fill: "#8DADD0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8945 9.51758L12.8945 9.7544L12.8945 11.3526L3.65542 11.3526L3.65542 9.51758L12.8945 9.51758Z",
    fill: "#8DADD0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHorizontalGroupableChartIcon);
export default __webpack_public_path__ + "static/media/horizontal-groupable-chart-icon.a68d4b8e7cf2e5ab83dfc77339cd7204.svg";
export { ForwardRef as ReactComponent };